import { useI18n } from "../i18n";

export function Footer() {
  const { t } = useI18n();
  const col = ["Instagram", "Telegram", "Twitter"];
  return (
    <footer className="relative bg-[var(--color-forest-deep)] text-[var(--color-cream)] pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-8 grid grid-cols-1 md:grid-cols-2 gap-10">
        <h3 className="font-serif text-3xl md:text-4xl text-[var(--color-cream)] max-w-md leading-tight">
          {t("footer.title")}
        </h3>
        <div className="grid grid-cols-3 gap-6 text-sm">
          {[0, 1, 2].map((c) => (
            <ul key={c} className="space-y-2">
              {col.map((x) => (
                <li key={x} className="opacity-85 hover:opacity-100 cursor-pointer">{x}</li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      <div className="max-w-[1280px] mx-auto px-8 mt-24 flex items-center justify-between text-sm">
        <span className="font-logo text-[13px] tracking-[0.2em]">ALVION</span>
        <div className="flex gap-12 opacity-85">
          <span className="cursor-pointer">{t("footer.contact")}</span>
          <span className="cursor-pointer">{t("footer.contact")}</span>
          <span className="cursor-pointer">{t("footer.contact")}</span>
        </div>
      </div>
    </footer>
  );
}
